// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3zUH2","select":"Header_select__31viQ","clinic":"Header_clinic__2lOtV"};